import React, { useState } from "react";
import PricingBox from "./PricingBox";
import {
  FaFire,
  FaDumbbell,
  FaHeart,
  FaGift,
  FaCircleInfo,
  FaUserGroup,
  FaListCheck,
  FaCircleCheck,
  FaMedal,
  FaAppleWhole,
  FaShieldHalved,
  FaWhatsapp,
  FaPhone,
} from "react-icons/fa6";

function Pricing() {
  const [activeTab, setActiveTab] = useState("early-bird");

  // ----- EARLY BIRD OFFERS (7 plans) -----
  const earlyBirdPlans = [
    {
      title: "3 + 1 Months",
      subtitle: "⚡ 4 Months Total Access",
      price: "2,799",
      duration: "/ 4 mo",
      badge: "+1 Month Free",
      badgeType: "green",
      isFeatured: false,
      features: [
        "1 Free Extra Month Included",
        "Full Gym & Cardio Access",
        "On-Floor Certified Coach Guidance",
        "Initial Fitness Assessment",
        "Locker & Changing Facilities",
      ],
    },
    {
      title: "3 + 3 Months",
      subtitle: "🔥 Buy 3 Get 3 Free (6 Mo Total)",
      price: "3,999",
      duration: "/ 6 mo",
      badge: "Buy 3 Get 3 Free",
      badgeType: "gold",
      isFeatured: true,
      features: [
        "3 Free Extra Months Included",
        "Complete 6-Month Training Split",
        "Customized Diet Guidelines",
        "Form & Technique Spotting",
        "Periodic Weight & Body Checks",
      ],
    },
    {
      title: "6 + 6 Months",
      subtitle: "🏆 Buy 6 Get 6 Free (1 Full Year)",
      price: "5,999",
      duration: "/ 12 mo",
      badge: "Buy 6 Get 6 Free",
      badgeType: "red",
      isFeatured: true,
      features: [
        "6 Free Extra Months (1 Full Year)",
        "Year-Long Physique Transformation",
        "Full Strength & Heavy Equipment",
        "Periodic Routine Upgrades",
        "Trainer Assistance & Coaching",
      ],
    },
    {
      title: "10 + 10 Months",
      subtitle: "💥 Buy 10 Get 10 Free (20 Mo Total)",
      price: "7,999",
      duration: "/ 20 mo",
      badge: "Buy 10 Get 10 Free",
      badgeType: "purple",
      isFeatured: false,
      features: [
        "10 Free Extra Months Included",
        "20 Months Extended Membership",
        "Lowest Long-Term Pricing (~₹400/m)",
        "Continuous Muscle & Fitness Plan",
        "Unisex Safe Training Floor",
      ],
    },
    {
      title: "12 + 3 Months",
      subtitle: "⭐ 15 Months Total Membership",
      price: "6,999",
      duration: "/ 15 mo",
      badge: "+3 Months Free",
      badgeType: "blue",
      isFeatured: false,
      features: [
        "3 Free Extra Months Added",
        "15 Months Continuous Training",
        "Cardio & Functional Training",
        "Coach Advice & Nutrition Tips",
        "Full Facility & Locker Access",
      ],
    },
    {
      title: "12 + 6 Months",
      subtitle: "🌟 1.5 Years Total Membership",
      price: "7,499",
      duration: "/ 18 mo",
      badge: "+6 Months Free",
      badgeType: "gold",
      isFeatured: false,
      features: [
        "6 Free Extra Months Added",
        "18 Months Total Gym Access",
        "Free Weights (Dumbbells to 50kg)",
        "Certified Coach Workout Planning",
        "Locker & Shower Access",
      ],
    },
    {
      title: "12 + 12 Months",
      subtitle: "👑 2 Full Years (24 Months Total)",
      price: "9,999",
      duration: "/ 24 mo",
      badge: "Buy 1 Yr Get 1 Yr Free",
      badgeType: "gold",
      isFeatured: true,
      features: [
        "Buy 1 Year, Get 1 Year Free (24 Mo)",
        "Best Overall Long-Term Value",
        "Complete Lifestyle Transformation",
        "Unlimited Equipment & Floor Access",
        "Priority Coach Guidance & Support",
      ],
    },
  ];

  // ----- REGULAR PACKAGES (5 plans) -----
  const regularPlans = [
    {
      title: "Monthly Plan",
      subtitle: "Flexible month-to-month pass",
      price: "849",
      duration: "/ month",
      badge: "Monthly",
      badgeType: "blue",
      isFeatured: false,
      features: [
        "One-Time Admission: ₹700 (Separate)",
        "Full Gym & Cardio Floor Access",
        "Certified Coach Support On Floor",
        "Free Weights & Pin Machines",
        "Locker & Changing Room Amenities",
      ],
    },
    {
      title: "3 Months Plan",
      subtitle: "Quarterly transformation split",
      price: "2,499",
      duration: "/ 3 months",
      badge: "Quarterly",
      badgeType: "blue",
      isFeatured: false,
      features: [
        "One-Time Admission: ₹700 (Separate)",
        "90-Day Structured Fitness Plan",
        "Basic Diet & Lifestyle Suggestions",
        "Form & Progress Checks",
        "Full Equipment & Floor Access",
      ],
    },
    {
      title: "6 Months Plan",
      subtitle: "Half-year serious commitment",
      price: "4,499",
      duration: "/ 6 months",
      badge: "Half Yearly",
      badgeType: "gold",
      isFeatured: true,
      features: [
        "One-Time Admission: ₹700 (Separate)",
        "Structured Exercise Split Routine",
        "Continuous Motivation & Spotting",
        "Body Composition Checkups",
        "Full Facility & Locker Access",
      ],
    },
    {
      title: "10 Months Plan",
      subtitle: "Extended training program",
      price: "6,999",
      duration: "/ 10 months",
      badge: "10 Months",
      badgeType: "purple",
      isFeatured: false,
      features: [
        "One-Time Admission: ₹700 (Separate)",
        "Periodic Routine Upgrades",
        "Cardio & Resistance Conditioning",
        "Certified Head Coach Oversight",
        "All Amenities & Facilities",
      ],
    },
    {
      title: "12 Months Plan",
      subtitle: "1 Full Year of unlimited fitness",
      price: "7,999",
      duration: "/ 12 months",
      badge: "Annual Legend",
      badgeType: "red",
      isFeatured: true,
      features: [
        "One-Time Admission: ₹700 (Separate)",
        "Full 365 Days Unlimited Access",
        "Comprehensive Transformation Guide",
        "Certified Coach Guidance",
        "All Amenities & Facilities Included",
      ],
    },
  ];

  // ----- COUPLE PACKAGES (3 plans) -----
  const couplePlans = [
    {
      title: "6 Months Couple",
      subtitle: "Train together with your partner",
      price: "7,000",
      duration: "/ 6 mo (2 Pax)",
      badge: "Couple 6M",
      badgeType: "purple",
      isFeatured: false,
      features: [
        "Valid for 2 Members (Couple/Partners)",
        "Full 6 Months Access for Both",
        "Shared Fitness Goals & Tracking",
        "Certified Floor Coach Support",
        "Locker & Shower Facilities for Both",
      ],
    },
    {
      title: "10 Months Couple",
      subtitle: "Extended partner fitness journey",
      price: "11,000",
      duration: "/ 10 mo (2 Pax)",
      badge: "Couple 10M",
      badgeType: "gold",
      isFeatured: true,
      features: [
        "Valid for 2 Members (Couple/Partners)",
        "10 Months Continuous Access for Both",
        "Partner Motivation & Routine Split",
        "Diet & Conditioning Guidance",
        "Complete Equipment & Floor Access",
      ],
    },
    {
      title: "12 Months Couple",
      subtitle: "1 Year Ultimate Dual Membership",
      price: "13,000",
      duration: "/ 12 mo (2 Pax)",
      badge: "Couple Annual Best",
      badgeType: "gold",
      isFeatured: true,
      features: [
        "Valid for 2 Members (Couple/Partners)",
        "Full 365 Days Access for Both",
        "Only ₹6,500 per person for a whole year!",
        "Personalized Form & Fitness Advice",
        "All Amenities & Equipment Access",
      ],
    },
  ];

  // ----- HELPERS -----
  const getTabCount = (tab) => {
    if (tab === "early-bird") return earlyBirdPlans.length;
    if (tab === "regular") return regularPlans.length;
    return couplePlans.length;
  };

  const renderPlans = () => {
    const plans =
      activeTab === "early-bird"
        ? earlyBirdPlans
        : activeTab === "regular"
          ? regularPlans
          : couplePlans;

    return plans.map((plan, idx) => (
      <PricingBox
        key={idx}
        title={plan.title}
        subtitle={plan.subtitle}
        price={plan.price}
        duration={plan.duration}
        effectivePrice={plan.effectivePrice}
        badge={plan.badge}
        badgeType={plan.badgeType}
        isFeatured={plan.isFeatured}
        features={plan.features}
      />
    ));
  };

  return (
    <section className="pricing-section" style={{ position: "relative", overflow: "hidden" }}>
      {/* ----- AMBIENT GLOW ----- */}
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 0 }}>
        <div className="orb orb1" style={{ top: '-15%', left: '-10%', width: '600px', height: '600px', background: '#ff0336', opacity: 0.12 }} />
        <div className="orb orb2" style={{ bottom: '-20%', right: '-10%', width: '500px', height: '500px', background: '#ffd600', opacity: 0.10 }} />
        <div className="orb orb3" style={{ top: '40%', left: '30%', width: '400px', height: '400px', background: '#7c3aed', opacity: 0.06 }} />
        {/* subtle grid overlay */}
        <div style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)',
          backgroundSize: '50px 50px',
          pointerEvents: 'none'
        }} />
      </div>

      <div style={{ position: "relative", zIndex: 10, padding: "64px 24px 80px", maxWidth: "1400px", margin: "0 auto" }}>
        {/* ----- HEADER (fresh style) ----- */}


        {/* ----- SEGMENTED CONTROLLER (glassmorph) ----- */}
        <div className="flex justify-center mb-10">
          <div className="inline-flex p-1.5 bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl shadow-2xl flex-wrap justify-center gap-1.5">
            {[
              { key: 'early-bird', label: 'Early Bird Offers', Icon: FaFire, color: '#ff0336' },
              { key: 'regular', label: 'Regular Packages', Icon: FaDumbbell, color: '#fbbf24' },
              { key: 'couple', label: 'Couple Packages', Icon: FaHeart, color: '#f472b6' },
            ].map((tab) => {
              const isActive = activeTab === tab.key;
              return (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`px-5 sm:px-7 py-3.5 rounded-xl font-black uppercase text-[12px] sm:text-[13px] tracking-wider transition-all duration-300 flex items-center gap-2.5 ${isActive
                      ? 'bg-gradient-to-r from-[#ffd600] to-amber-400 text-black shadow-lg shadow-yellow-500/20 scale-[1.02]'
                      : 'text-neutral-400 hover:text-white hover:bg-white/5'
                    }`}
                >
                  <tab.Icon className={`text-[14px] ${isActive ? 'text-black' : 'text-neutral-500'}`} />
                  <span>{tab.label}</span>
                  <span className={`text-[10px] px-2 py-0.5 rounded-full font-black ${isActive ? 'bg-black/15 text-black' : 'bg-white/5 text-neutral-400'
                    }`}>
                    {getTabCount(tab.key)}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        {/* ----- CONTEXT BANNER (dynamic) ----- */}
        <div className="max-w-2xl mx-auto mb-12 text-center">
          {activeTab === 'early-bird' && (
            <div className="inline-flex items-center gap-3 bg-gradient-to-r from-amber-500/10 via-red-500/10 to-transparent border border-amber-500/20 px-5 py-3 rounded-2xl text-[13px] sm:text-[14px] text-amber-100 backdrop-blur-md shadow-lg">
              <FaGift className="text-[#ffd600] text-lg shrink-0" />
              <span><strong>Eachanari Launch:</strong> Get massive bonus months (up to <strong>12+12 months free</strong>) for a limited time!</span>
            </div>
          )}
          {activeTab === 'regular' && (
            <div className="inline-flex items-center gap-3 bg-neutral-900/80 border border-neutral-700/60 px-5 py-3 rounded-2xl text-[13px] sm:text-[14px] text-neutral-200 backdrop-blur-md shadow-lg">
              <FaCircleInfo className="text-[#ffd600] text-lg shrink-0" />
              <span><strong>Admission Fee:</strong> One-time registration of <strong>₹700</strong> applies.</span>
            </div>
          )}
          {activeTab === 'couple' && (
            <div className="inline-flex items-center gap-3 bg-pink-500/10 border border-pink-500/20 px-5 py-3 rounded-2xl text-[13px] sm:text-[14px] text-pink-100 backdrop-blur-md shadow-lg">
              <FaUserGroup className="text-pink-400 text-lg shrink-0" />
              <span><strong>Couple Dual Plan:</strong> Covers complete membership for <strong>both partners</strong> together.</span>
            </div>
          )}
        </div>

        {/* ----- CARDS GRID ----- */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 360px), 1fr))", gap: "28px", alignItems: "start" }}>
          {renderPlans()}
        </div>

        {/* ----- EARLY BIRD QUICK COMPARISON TABLE (only for early bird) ----- */}
        {activeTab === 'early-bird' && (
          <div className="mt-16 bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-6 sm:p-8 max-w-5xl mx-auto shadow-2xl">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-6 pb-4 border-b border-white/10">
              <div>
                <h3 className="text-[18px] sm:text-[20px] font-black uppercase text-white tracking-tight flex items-center gap-2">
                  <FaListCheck className="text-[#ffd600]" />
                  Early Bird Price Breakdown
                </h3>
                <p className="text-neutral-400 text-[12.5px] sm:text-[13.5px]">Compare all 7 Eachanari launch offers</p>
              </div>
              <span className="bg-red-600/20 border border-red-500/30 text-red-400 text-[11px] font-black uppercase px-3 py-1 rounded-full">⚡ Limited</span>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-left text-[13px] sm:text-[14px]">
                <thead>
                  <tr className="border-b border-white/10 text-neutral-400 uppercase text-[11px] tracking-wider font-extrabold">
                    <th className="py-3 px-3">Offer</th>
                    <th className="py-3 px-3">Duration</th>
                    <th className="py-3 px-3">Price</th>
                    <th className="py-3 px-3">Monthly</th>
                    <th className="py-3 px-3 text-right">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-white/5 font-medium text-neutral-200">
                  {earlyBirdPlans.map((plan, i) => (
                    <tr key={i} className={`hover:bg-white/5 transition ${plan.isFeatured ? 'bg-yellow-500/5' : ''}`}>
                      <td className="py-3.5 px-3 font-bold text-white">{plan.title}</td>
                      <td className="py-3.5 px-3 text-neutral-300">{plan.duration.replace('/ ', '')}</td>
                      <td className="py-3.5 px-3 font-black text-[#ffd600]">₹{plan.price}</td>
                      <td className="py-3.5 px-3 text-neutral-400">{plan.effectivePrice}</td>
                      <td className="py-3.5 px-3 text-right">
                        <a
                          href={`https://wa.me/918637488702?text=Hi%20Coach%20Nandha%2C%20I%20want%20the%20${encodeURIComponent(plan.title)}%20(Rs.${plan.price})%20plan!`}
                          target="_blank"
                          rel="noreferrer"
                          className={`text-[11px] font-bold uppercase px-3 py-1.5 rounded-lg transition ${plan.isFeatured
                              ? 'bg-[#ffd600] text-black hover:bg-yellow-400'
                              : 'bg-neutral-800 hover:bg-[#ffd600] hover:text-black text-white'
                            }`}
                        >
                          Book
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ----- PERKS SECTION (premium redesign) ----- */}
        <div className="perks-wrapper mt-16 sm:mt-24">
          {/* Top divider with center glow */}
          <div className="perks-divider" />

          {/* Section heading */}
          <div className="perks-heading-block">
            <span className="perks-eyebrow flex items-center gap-2">
              <FaCircleCheck className="text-yellow-400" /> Included in Every Plan
            </span>
            <h3 className="perks-title">
              Every Membership<br />
              <span className="perks-title-gradient">Includes Premium Perks</span>
            </h3>
            <p className="perks-subtitle">
              No hidden extras. No up-sells. Every tier unlocks the full Fat2Fit experience from day one.
            </p>
          </div>

          {/* Cards */}
          <div className="perks-grid">
            {[
              {
                Icon: FaMedal,
                label: 'Certified Coach Guidance',
                desc: 'On-floor coaching by Mr. India Junior Winner G. Nandha Kumar & team.',
                accent: '#ffd600',
                glow: 'rgba(255,214,0,0.15)',
                tag: 'Elite Coaching',
                stat: '',
                statLabel: 'Experienced Coaches',
              },
              {
                Icon: FaDumbbell,
                label: 'Heavy-Duty Equipment',
                desc: 'Olympic squat racks, dumbbells up to 50 kg, cable machines & commercial cardio.',
                accent: '#ffd600',
                glow: 'rgba(255,214,0,0.15)',
                tag: 'World-Class Gear',
                statLabel: 'Max Dumbbell',
              },
              {
                Icon: FaAppleWhole,
                label: 'Nutrition & Diet Support',
                desc: 'Custom meal advice tailored for fat loss, muscle building, or maintenance goals.',
                accent: '#ffd600',
                glow: 'rgba(255,214,0,0.15)',
                tag: 'Personalised Plans',
                statLabel: 'Customised',
              },
              {
                Icon: FaShieldHalved,
                label: 'Lockers & Clean Amenities',
                desc: 'Secure lockers, hygienic changing rooms with separate male & female amenities.',
                accent: '#ffd600',
                glow: 'rgba(255,214,0,0.15)',
                tag: 'Safe & Hygienic',
                statLabel: 'Secured Access',
              },
            ].map((item, idx) => (
              <div
                key={idx}
                className="perk-card"
                style={{ '--accent': item.accent, '--glow': item.glow }}
              >
                {/* Animated corner accent */}
                <div className="perk-corner-tl" />
                <div className="perk-corner-br" />

                {/* Top row */}
                <div className="perk-top-row">
                  <div className="perk-icon-hex flex items-center justify-center">
                    <item.Icon className="text-yellow-400 text-lg" />
                  </div>
                  <span className="perk-tag">{item.tag}</span>
                </div>

          

                {/* Content */}
                <h4 className="perk-label">{item.label}</h4>
                <p className="perk-desc">{item.desc}</p>

                {/* Bottom glowing bar */}
                <div className="perk-bottom-bar" />
              </div>
            ))}
          </div>
        </div>

        {/* ----- WHATSAPP CONSULTATION BAR (new design) ----- */}
        <div className="mt-12 sm:mt-16 bg-gradient-to-r from-neutral-950/90 via-neutral-900/90 to-neutral-950/90 border border-yellow-500/20 rounded-3xl p-6 sm:p-10 max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6 shadow-2xl backdrop-blur-xl">
          <div>
            <h3 className="text-[20px] sm:text-[22px] font-extrabold text-white">
              Need Help Choosing?
            </h3>
            <p className="text-neutral-400 text-[13.5px] sm:text-[14.5px] mt-1 max-w-lg leading-relaxed">
              Chat directly with Head Coach Nandha Kumar for personalized recommendations.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0 w-full md:w-auto">
            <a
              href="https://wa.me/918637488702?text=Hi%20Coach%20Nandha%2C%20I%20need%20guidance%20in%20selecting%20the%20best%20gym%20package%20for%20me!"
              target="_blank"
              rel="noreferrer"
              className="bg-gradient-to-r from-[#ffd600] to-amber-500 hover:opacity-90 text-black font-black uppercase text-[12px] sm:text-[13px] px-6 py-3.5 rounded-xl transition flex items-center justify-center gap-2 shadow-lg shadow-yellow-500/20"
            >
              <FaWhatsapp className="text-lg" /> WhatsApp Coach
            </a>
            <a
              href="tel:8637488702"
              className="bg-white/5 border border-white/10 hover:border-white/30 text-white font-bold uppercase text-[12px] sm:text-[13px] px-5 py-3.5 rounded-xl transition flex items-center justify-center gap-2"
            >
              <FaPhone className="text-[#ffd600]" /> +91 86374 88702
            </a>
          </div>
        </div>
      </div>

      <style>{`
        .pricing-section {
          background: radial-gradient(ellipse at 25% 0%, #1a1030 0%, #0d0e16 45%, #060609 100%) !important;
          background-image: none !important;
          border-radius: 2.5rem;
        }
        .orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(120px);
        }
        @keyframes ping {
          75%, 100% { transform: scale(1.8); opacity: 0; }
        }
        .animate-ping {
          animation: ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
        }

        /* ========== PERKS SECTION ========== */
        .perks-wrapper {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 8px;
        }

        /* Glowing centre divider */
        .perks-divider {
          position: relative;
          width: 100%;
          height: 1px;
          background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.06) 30%, rgba(255,214,0,0.35) 50%, rgba(255,255,255,0.06) 70%, transparent 100%);
          margin-bottom: 56px;
        }
        .perks-divider::after {
          content: '';
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 80px;
          height: 6px;
          background: #ffd600;
          border-radius: 99px;
          filter: blur(8px);
        }

        /* Heading block */
        .perks-heading-block {
          text-align: center;
          margin-bottom: 52px;
        }
        .perks-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: #ffd600;
          background: rgba(255,214,0,0.08);
          border: 1px solid rgba(255,214,0,0.2);
          padding: 6px 16px;
          border-radius: 99px;
          margin-bottom: 20px;
        }
        .perks-title {
          font-size: clamp(30px, 5vw, 52px);
          font-weight: 900;
          color: #fff;
          line-height: 1.1;
          letter-spacing: -0.02em;
          margin: 0 0 16px;
        }
        .perks-title-gradient {
          background: linear-gradient(120deg, #ffd600 0%, #ff6a00 55%, #ff0336 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .perks-subtitle {
          font-size: 15px;
          color: #9ca3af;
          max-width: 520px;
          margin: 0 auto;
          line-height: 1.7;
        }

        /* Grid */
        .perks-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(min(100%, 260px), 1fr));
          gap: 20px;
        }

        /* Card */
        .perk-card {
          position: relative;
          background: rgba(255,255,255,0.03);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 24px;
          padding: 28px 24px 24px;
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
          cursor: default;
        }
        .perk-card::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse at 20% 10%, var(--glow) 0%, transparent 65%);
          border-radius: inherit;
          pointer-events: none;
          opacity: 0;
          transition: opacity 0.35s ease;
        }
        .perk-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 50px -10px var(--glow), 0 0 0 1px var(--accent);
          border-color: rgba(255,255,255,0.18);
        }
        .perk-card:hover::before {
          opacity: 1;
        }

        /* Corner accents (L-shaped lines) */
        .perk-corner-tl,
        .perk-corner-br {
          position: absolute;
          width: 24px;
          height: 24px;
          pointer-events: none;
          transition: opacity 0.3s;
          opacity: 0;
        }
        .perk-corner-tl {
          top: 14px; left: 14px;
          border-top: 2px solid var(--accent);
          border-left: 2px solid var(--accent);
          border-radius: 4px 0 0 0;
        }
        .perk-corner-br {
          bottom: 14px; right: 14px;
          border-bottom: 2px solid var(--accent);
          border-right: 2px solid var(--accent);
          border-radius: 0 0 4px 0;
        }
        .perk-card:hover .perk-corner-tl,
        .perk-card:hover .perk-corner-br {
          opacity: 1;
        }

        /* Top row: icon + tag */
        .perk-top-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;
        }

        /* Hexagonal icon container */
        .perk-icon-hex {
          width: 52px;
          height: 52px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          color: var(--accent);
          background: var(--glow);
          border: 1px solid var(--accent);
          border-radius: 14px;
          box-shadow: 0 0 16px -4px var(--accent);
          transition: box-shadow 0.3s ease;
        }
        .perk-card:hover .perk-icon-hex {
          box-shadow: 0 0 28px -4px var(--accent);
        }

        /* Tag chip */
        .perk-tag {
          font-size: 10px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.12em;
          color: var(--accent);
          background: var(--glow);
          border: 1px solid var(--accent);
          padding: 4px 10px;
          border-radius: 99px;
          opacity: 0.85;
        }

        /* Stat row */
        .perk-stat-row {
          display: flex;
          align-items: baseline;
          gap: 6px;
          margin-bottom: 14px;
        }
        .perk-stat-number {
          font-size: 38px;
          font-weight: 900;
          line-height: 1;
          color: var(--accent);
          letter-spacing: -0.03em;
          filter: drop-shadow(0 0 12px var(--accent));
        }
        .perk-stat-label {
          font-size: 11px;
          font-weight: 700;
          color: rgba(255,255,255,0.35);
          text-transform: uppercase;
          letter-spacing: 0.1em;
        }

        /* Label + desc */
        .perk-label {
          font-size: 16px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 8px;
          line-height: 1.3;
        }
        .perk-desc {
          font-size: 13px;
          color: #6b7280;
          line-height: 1.7;
          margin: 0;
        }

        /* Bottom glowing bar */
        .perk-bottom-bar {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 2px;
          background: linear-gradient(90deg, transparent 0%, var(--accent) 50%, transparent 100%);
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        .perk-card:hover .perk-bottom-bar {
          opacity: 0.7;
        }

        @media (max-width: 640px) {
          .perks-grid {
            grid-template-columns: 1fr;
          }
          .perk-stat-number {
            font-size: 30px;
          }
        }
      `}</style>
    </section>
  );
}

export default Pricing;